import { ClubEvent, Participant } from "../types";

/**
 * Pelaajan tila tapahtumassa (docs/ideat.md A7).
 *
 * Aiemmin kortti tunsi vain "mukana" ja "ei mukana", joten kutsuttu
 * pelaaja näki saman Ilmoittaudu-napin kuin kuka tahansa — mikään ei
 * kertonut kutsusta, eikä ollut tapaa sanoa "en pääse". Ero on datassa
 * valmiina:
 *
 * - going:    osallistujarivi, confirmed: true
 * - declined: confirmed: false ja source "player" — pelaaja vastasi itse
 * - invited:  ylläpitäjän lisäämä rivi ilman vahvistusta, tai nimi
 *             tapahtuman invitedNames-listassa (sendEventInvites)
 * - open:     ei kutsua; tavallinen Ilmoittaudu
 */
export type AttendanceStatus = "going" | "declined" | "invited" | "open";

const norm = (s: string) => s.trim().toLowerCase().replace(/\s+/g, " ");

export function attendanceStatus(
  ev: Pick<ClubEvent, "invitedNames">,
  me: Participant | null | undefined,
  myName?: string,
): AttendanceStatus {
  if (me?.confirmed) return "going";
  if (me && me.source === "player") return "declined";
  if (me) return "invited";
  if (myName && (ev.invitedNames ?? []).some(n => norm(n) === norm(myName))) return "invited";
  return "open";
}
